import React from 'react';
import {Styles} from '../../../../../config/design/styles';
import { withStyles } from '@material-ui/core/styles';
import {connect} from "trim-redux";
import {Link, withRouter} from "react-router-dom";
import { withSnackbar } from 'notistack';
import withWidth from "@material-ui/core/withWidth/withWidth";
import Grid from "@material-ui/core/Grid/Grid";
import {Translate} from "../../../../../config/Translate";
import Title from "../../../../components/elements/Title";
import CommissionField from "./components/CommissionField";
import SubTitle from "../../../../components/elements/SubTitle";
import HidePriceField from "./components/HidePriceField";
import ServicesPriceField from "./components/ServicesPriceField";
import XPriceField from "./components/XPriceField";
import GlobalNeedVerificationField from "./components/GlobalNeedVerificationField";
import TextField from "@material-ui/core/TextField/TextField";
import validator from "validator";
import axios from "axios";
import {defaultVariabls} from "../../../../../config";
import LoadingButton from "../../../../components/elements/LoadingButton";

import SaveRoundedIcon from '@material-ui/icons/SaveRounded';
import {LoadSetting} from "../../../../../config/Security";
import SingleFileChooser from "../../../fileManager/Components/SingleFileChooser";
import SiteColorPicker from "../../template/components/SiteColorPicker";

class SiteSettings extends React.Component {
    classes = this.props.classes;
    state = {
        fields:{
            app_name: this.props.setting.app_name
        },
        site_logo_file:this.props.setting.site_logo_file,
        site_logo_id:this.props.setting.site_logo_file.id,
        favicon_file:this.props.setting.favicon_file,
        favicon_id:this.props.setting.favicon_file.id,
        square_logo_file:this.props.setting.square_logo_file,
        square_logo_id:this.props.setting.square_logo_file.id,
        page_header_file:this.props.setting.page_header_file,
        page_header_id:this.props.setting.page_header_file.id,

        SubmitLoading:false,
        errors:{}
    };
    handleChange(e){
        let {errors,fields} = this.state;
        let target = e.target;
        fields[target.name] = target.value;
        errors[target.name] = "";
        this.setState({fields});
    }

    handleValidation(callback){
        let { fields } = this.state;
        let errors = {};
        let formIsValid = true;

        //name
        if(validator.isEmpty(fields.app_name)){
            formIsValid = false;
            errors['app_name'] = Translate.emptyField;
        }

        if(!formIsValid){
            this.props.enqueueSnackbar(Translate.someFieldsHasError, {
                variant: 'warning',
            });
            this.setState({
                errors,
                SubmitLoading:false,
            })
        }
        return callback(formIsValid)
    }

    handleRequest(){
        let { fields,site_logo_id,favicon_id,page_header_id,square_logo_id} = this.state;
        let data = new FormData();
        data.append('app_name', fields.app_name);
        data.append('site_logo_id', site_logo_id);
        data.append('favicon_id', favicon_id);
        data.append('page_header_id', page_header_id);
        data.append('square_logo_id', square_logo_id);


        let loginToken = localStorage.getItem('ACT');
        let config = {
            headers: {
                Accept: 'application/json',
                Authorization: `Bearer ${loginToken}`
            }
        };
        axios.post(`${defaultVariabls.url}/settings/save`, data, config)
            .then(async response => {
                await LoadSetting();
                await this.setState({
                    loading:false,
                    SubmitLoading: false,
                });
                await this.props.enqueueSnackbar(Translate.allChangesSaved, {
                    variant: 'success',
                });
            })
            .catch(error => {
                console.log(error.response)
                this.props.enqueueSnackbar(Translate.allChangesSavingFailed, {
                    variant: 'error',
                });
                this.setState({
                    loading:false,
                    SubmitLoading: false,
                });
            });

    }
    handleSubmit(e){
        this.setState({
            SubmitLoading: true
        })
        e.preventDefault();
        this.handleValidation((valid) =>{
            if(valid) {
                this.handleRequest();
            }
        });
    }
    handleChangeFile(field,val){
        if(!!val){
            if(field === "site_logo"){
                this.setState({
                    site_logo_id:val.id,
                    site_logo_file:val
                })
            }
            if(field === "square_logo"){
                this.setState({
                    square_logo_id:val.id,
                    square_logo_file:val
                })
            }
            if(field === "favicon"){
                this.setState({
                    favicon_id:val.id,
                    favicon_file:val
                })
            }
            if(field === "page_header"){
                this.setState({
                    page_header_id:val.id,
                    page_header_file:val
                })
            }
        }

    }
    render(){
        let {errors,fields,SubmitLoading,site_logo_file,favicon_file,page_header_file,square_logo_file} = this.state;
        return (
            <Grid container spacing={2}>
                <Grid item xs={12} md={6}>
                    <TextField
                        variant="outlined"
                        value={fields.app_name}
                        fullWidth
                        size="app_name"
                        label={Translate.app_name}
                        name="app_name"
                        onChange={this.handleChange.bind(this)}
                        error = {!!errors['app_name']}
                        helperText={errors['app_name']}
                    />
                </Grid>
                <Grid item xs={12} md={6}>
                    <SiteColorPicker/>
                </Grid>
                <Grid item xs={6} md={4} lg={3}>
                    <SingleFileChooser
                        title={Translate.site_logo}
                        initial={site_logo_file}
                        onChange={(file) => this.handleChangeFile('site_logo',file)}
                    />
                </Grid>
                <Grid item xs={6} md={4} lg={3}>
                    <SingleFileChooser
                        title={Translate.favicon}
                        initial={favicon_file}
                        onChange={(file) => this.handleChangeFile('favicon',file)}
                    />
                </Grid>
                <Grid item xs={6} md={4} lg={3}>
                    <SingleFileChooser
                        title={Translate.square_logo}
                        initial={square_logo_file}
                        onChange={(file) => this.handleChangeFile('square_logo',file)}
                    />
                </Grid>
                <Grid item xs={6} md={4} lg={3}>
                    <SingleFileChooser
                        title={Translate.page_header}
                        initial={page_header_file}
                        onChange={(file) => this.handleChangeFile('page_header',file)}
                    />
                </Grid>
                <Grid item xs={12}>
                    <LoadingButton
                        variant="contained"
                        color="primary"
                        startIcon={<SaveRoundedIcon/>}
                        onClick={this.handleSubmit.bind(this)}
                        loading={SubmitLoading}
                    >
                        {Translate.saveChanges}
                    </LoadingButton>
                </Grid>
            </Grid>
        );
    }
}

const mstp = state => ({
    locale: state.locale,
    about: state.about,
    setting: state.setting,
});
export default withWidth()(withSnackbar(withRouter(withStyles(Styles)(connect(mstp)(SiteSettings)))));